import { Component, Input } from '@angular/core';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { FormValidators } from '@validators/form.validators';

export enum EnumPasswordStrengthLevel {
    Empty = 'empty',
    Weak = 'weak',
    Fair = 'fair',
    Strong = 'strong'
}

@Component({
    selector: 'password-strength-meter',
    templateUrl: './password-strength-meter.component.html',
    styleUrls: ['./password-strength-meter.component.scss'],
})
export class PasswordStrengthMeterComponent {

    /**
     * Control reactivo do qual é lido o valor da palavra-passe.
     * Alternativa ao input "password" para uso directo com Reactive Forms.
     */
    @Input() control?: FormControl | UntypedFormControl | any;

    /**
     * Valor da palavra-passe, caso não seja usado um FormControl.
     */
    @Input() password?: string;

    public get Value(): string {
        return this.control ? this.control.value : this.password;
    }

    public get HasValue(): boolean {
        return !!this.Value;
    }

    public get Score(): number {
        return FormValidators.HelperGetPasswordStrength(this.Value);
    }

    public get Level(): EnumPasswordStrengthLevel {

        if (!this.HasValue) return EnumPasswordStrengthLevel.Empty;

        if (this.Score < 35) return EnumPasswordStrengthLevel.Weak;

        if (this.Score < 65) return EnumPasswordStrengthLevel.Fair;

        return EnumPasswordStrengthLevel.Strong;
    }

    public get FilledBars(): number {
        switch (this.Level) {
            case EnumPasswordStrengthLevel.Weak: return 1;
            case EnumPasswordStrengthLevel.Fair: return 2;
            case EnumPasswordStrengthLevel.Strong: return 3;
            default: return 0;
        }
    }

    public get Label(): string {
        switch (this.Level) {
            case EnumPasswordStrengthLevel.Weak: return 'Fraca';
            case EnumPasswordStrengthLevel.Fair: return 'Razoável';
            case EnumPasswordStrengthLevel.Strong: return 'Forte';
            default: return '';
        }
    }
}
